import { useTestStore } from '@/store/useTestStore';
import { t } from '@/i18n/translations';
import { useDeviceInfo } from '@/hooks/useDeviceInfo';
import { DeviceInfo } from '@/components/DeviceInfo';
import { now, fmtMs } from '@/utils/format';

export function Overview() {
  const { language, deviceMode, autoRunning, startAutoRun, getAutoProgress } = useTestStore();
  const info = useDeviceInfo();

  return (
    <div className="border border-border rounded-[18px] bg-white/[.02] p-4">
      <h2 className="text-[22px] font-black tracking-tight mb-1.5">
        {t('overview.title', language)}
      </h2>
      <p className="text-sm text-muted leading-snug mb-3.5">
        {t('overview.desc', language)}
      </p>

      <div className="h-px bg-border my-3.5" />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <DeviceInfo info={info} />

        <div className="border border-border rounded-[18px] bg-white/[.01] p-3">
          <h3 className="text-sm font-bold mb-2">
            {deviceMode === 'tv' ? t('mode.tv', language) : t('mode.mobile', language)}
          </h3>
          <p className="text-xs text-muted leading-relaxed">
            {deviceMode === 'tv' ? t('overview.tvDesc', language) : t('overview.mobileDesc', language)}
          </p>
        </div>
      </div>

      <div className="h-px bg-border my-3.5" />

      <p className="text-xs text-muted">{t('overview.warning', language)}</p>

      <div className="h-px bg-border my-3.5" />

      <div className="flex flex-wrap gap-2.5 items-center">
        <button
          className="btn btn-primary"
          onClick={() => {
            try {
              document.documentElement.requestFullscreen?.();
            } catch {
              // not available
            }
          }}
        >
          {t('overview.fullscreen', language)}
        </button>
        <button
          className="btn"
          onClick={() => {
            const t0 = now();
            let x = 0;
            for (let i = 0; i < 2e6; i++) x = (x + i) % 97;
            alert('Warm-up: ' + fmtMs(now() - t0) + ' (x=' + x + ')');
          }}
        >
          {t('overview.warmup', language)}
        </button>
        <div className="flex-1" />
        <button
          className="btn btn-primary text-lg px-6"
          onClick={startAutoRun}
          disabled={autoRunning}
        >
          {autoRunning
            ? `${t('overview.running', language)} ${getAutoProgress()}`
            : t('overview.runAll', language)}
        </button>
      </div>
    </div>
  );
}
